import { RequiredQueryKeyFilter, createDefaultQueryKeysGenerator } from 'core/query/constants';

interface AwsSuppressedEmailsListKeyFilter extends RequiredQueryKeyFilter {
  domainsKey?: string;
}

type AwsSuppressedEmailsDetailKeyFilter = RequiredQueryKeyFilter;

export const awsSuppressedEmailsQueryKeys = createDefaultQueryKeysGenerator<
  AwsSuppressedEmailsListKeyFilter,
  AwsSuppressedEmailsDetailKeyFilter
>({
  keyDataType: 'aws-suppressed-emails',
});
